import React, {useState} from 'react';
import {Button, CssBaseline, TextField, Typography, Container} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import logo from '../media/img/logo-2.svg'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100vh',
    paddingBottom: '40px',
  },
  
  logo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(5),
  },

  paper: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#FAFAFA',
    boxShadow: '0px 19px 38px rgba(0, 0, 0, 0.3), 0px 15px 12px rgba(0, 0, 0, 0.22)',
    borderRadius: '2px',
  },
  
  title: {
    marginBottom: theme.spacing(1),
    color: '#333',
  },

  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },

  input: {
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#90C71A',
    },
    
    '& .Mui-focused.MuiInput-underline:after': {
      borderColor: '#90C71A',
    },
    
    '& .MuiInput-underline:not(".Mui-error"):after': {
      borderColor: '#90C71A',
    },
  },

  submit: {
    margin: theme.spacing(3, 0, 0),
    background: '#90C71A',
    color: '#fff',
  },
}));

export default function AuthForm(props) {
  const classes = useStyles();

  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const changeLogin = (e) => {
    setLogin(e.target.value);
    props.changeInput(e.target.name)
  };
  
  const changePassword = (e) => {
    setPassword(e.target.value);
    props.changeInput(e.target.name)
  };

  return (
    <Container className={classes.container} component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.logo}>
        <img src={logo} alt='Логотип' />
      </div>
      <div className={classes.paper}>
        <form className={classes.form} validate='true'>
          <Typography component="h1" variant="h6" className={classes.title}>Вход в личный кабинет</Typography>
          <TextField
            className={classes.input}
            margin="normal"
            required
            fullWidth
            id="login"
            label="Логин"
            name="login"
            autoComplete="login"
            error={props.loginMessage? true : false}
            helperText={props.loginMessage}
            onChange={(e) => changeLogin(e)}
          />
          <TextField
            className={classes.input}
            margin="normal"
            required
            fullWidth
            name="password"
            label="Пароль"
            type="password"
            id="password"
            autoComplete="current-password"
            error={props.passwordMessage? true : false}
            helperText={props.passwordMessage}
            onChange={(e) => changePassword(e)}
          />
          <Button
            type="submit"
            variant="contained"
            className={classes.submit}
            to="/"
            onClick={(e) => props.submitForm(e, {login, password})}
          >
            ВОЙТИ
          </Button>
        </form>
      </div>
    </Container>
  );
}